(function($){
$(document).ready(function(){
var tabs=$(".tabs"),
tabsLabels=tabs.children("ul"),
tabLabel=tabsLabels.find("a"),
tabsContent=tabs.children("div");
if(tabsLabels.find(".active-tab").length===0){
tabsLabels.children("li:first").addClass("active-tab");
tabsContent.children("div:first").addClass("active-tab-content");
}else{
/* location 1 */
var activeTabVal=tabsLabels.find(".active-tab a").attr("href");
if(activeTabVal && activeTabVal!="#" && activeTabVal.substring(0)==="#" && tabsContent.find(activeTabVal).length!=0){
/* find content based on id */
tabsContent.find(activeTabVal).addClass("active-tab-content"); 
}else{
/* find content based on DOM index */
tabsContent.children("div").eq(tabsLabels.find(".active-tab").index()).addClass("active-tab-content");
}
}
tabLabel.click(function(e){
e.preventDefault();
var tabID=$(this).attr("href"),
targetTab, /* we remove the previous value to avoid js errors */
activeTab=tabsLabels.find(".active-tab"),
activeTabContent=tabsContent.find(".active-tab-content");
/* location 2 */
if(tabID && tabID!="#" && tabID.substring(0)==="#" && tabsContent.find(tabID).length!=0){
/* find content based on id */
targetTab=tabsContent.find(tabID); 
}else{
/* find content based on DOM index */
tabID=$(this).parent().index(); 
targetTab=tabsContent.children("div").eq(tabID);
}
activeTab.add(activeTabContent).removeClass("active-tab active-tab-content");
$(this).parent().addClass("active-tab");
targetTab.addClass("active-tab-content");
});
});
})(jQuery);